import { SiriusBaseComponent } from 'sirius-framework';
import { ViewChild, Component } from '@angular/core';
import { SharedModel } from '../../models/shared.model'
import { Subscription } from 'rxjs'; 
import { CommonService } from '../../service/shared.service';

@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.css']
})
export class FooterComponent extends SiriusBaseComponent<any>  {
     
    copyRightText: string = '© 2026 QNB Bank A.Ş.'; 
    privacyPolicyText: string = 'Kişisel Verilerin Korunması';
    personalDataText: string = 'Gizlilik Politikası'; 
    termsOfUse: string = 'Kullanım Koşulları';
    termsOfPricing: string = 'Ücret ve Bilgilendirme';
    callCenter: string = 'Çağrı Merkezi';
    aboutPage:string ="Nasıl Kullanılır?";
    cookieInfoText: string = 'Çerez Aydınlatma';
     
    documentOpen: boolean = false;
    openDocumentId: string;
    docTitle: string; 
    @ViewChild('kvkkPopup') kvkkPopUp: any; 
    @ViewChild('cookieinfoPopup') cookieinfoPopUp: any;
    kvkkTitle: string;
    kvkkMessage: string;
    cookieinfoTitle: string;
    cookieinfoMessage: string; 
    isLoggedIn: boolean = false;
    subscriptionLoggedId: Subscription;
    showAboutLink: boolean = false;

    constructor(private commonService: CommonService )
    {
        super();
    }

    
    OnInit() { 
        this.subscriptionLoggedId = this.commonService.isLoggedin.subscribe(state => {
            this.isLoggedIn = (state == true);
        });

        //this.commonService.getDocumentList();

        let showAboutLinkValue = this.resourceService.getResource("showAboutLinkValue");
        this.showAboutLink = showAboutLinkValue == "1" ? true : false;
    }
     
    OpenTermsOfPricing() { 
        let docList = this.commonService.publicDocList;
        if (docList) {
            this.openDocumentId = docList.ViewModelList[0].DocumentId;
            this.docTitle = docList.ViewModelList[0].Name;
            this.documentOpen = true;
        } else {
            console.log("İlgili doküman sistemde bulunamadı."); 
        }
    }

    OpenTermsOfUse() {
        let docList = this.commonService.publicDocList;
        if (docList) {
            this.openDocumentId = docList.ViewModelList[1].DocumentId;
            this.docTitle = docList.ViewModelList[1].Name;
            this.documentOpen = true;
        }
        else {
            console.log("İlgili doküman sistemde bulunamadı."); 
        }
    }

  OpenPrivacyPolicy() {

    this.kvkkTitle = this.commonService.getKvvkTitle();
     this.kvkkMessage = this.resourceService.getResource(SharedModel.Kvkk);
     this.kvkkPopUp.open(this.kvkkTitle, this.kvkkMessage);
    }

    closeDocument(title: any) {
        this.documentOpen = false;
    }
    cancelDocument(title: any) {
        this.documentOpen = false;
    }

    OpenPrivacyPage() {
      window.open("https://www.qnb.com.tr/destek/gizlilik-politikasi", "_blank");
    }

    OpenCallCenter() {
      window.open("https://www.qnb.com.tr/724-bankacilik/cagri-merkezi", "_blank");
    }

    OpenAbout() {
      window.open("https://www.qnb.com.tr/guvenli-odeme-sistemi", "_blank");
    }

    OpenCookieInfo() {
        this.cookieinfoTitle = 'Çerez Aydınlatma Metni';
        this.cookieinfoMessage = this.resourceService.getResource('CookieInfo');
        this.cookieinfoPopUp.open(this.cookieinfoTitle, this.cookieinfoMessage);
    }
    
}
